const resolveBackendOrigin = (): string => {
  const envBase = (process.env.REACT_APP_API_URL || '').trim();
  if (envBase) {
    try {
      return new URL(envBase, window.location.origin).origin;
    } catch {
      // Continue with fallback below.
    }
  }
  // Uploaded files are exposed through the frontend's same-origin proxy.
  return window.location.origin;
};

export const toProductImageUrl = (image?: string): string => {
  if (!image) return '';
  if (image.startsWith('http://') || image.startsWith('https://')) return image;
  const base = resolveBackendOrigin();
  return `${base}${image.startsWith('/') ? image : `/${image}`}`;
};

export const normalizeProductImageInput = (value?: string): string => {
  const image = String(value || '').trim();
  if (!image) return '';
  try {
    const url = new URL(image);
    if (url.hostname === 'drive.google.com') {
      const pathMatch = url.pathname.match(/\/file\/d\/([^/]+)/);
      const fileId = pathMatch?.[1] || url.searchParams.get('id');
      if (fileId && /^[A-Za-z0-9_-]+$/.test(fileId)) {
        return `https://lh3.googleusercontent.com/d/${fileId}`;
      }
    }
  } catch {
    return image;
  }
  return image;
};
